var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10C17.25 9.77 17.24 9.55 17.22 9.32L19.08 7.91C19.48 7.61 19.59 7.05 19.34 6.61L17.47 3.38C17.22 2.94 16.68 2.76 16.22 2.96L14.07 3.87C13.7 3.61 13.31 3.38 12.9 3.19L12.61 0.88C12.55 0.38 12.12 0 11.62 0H7.89003C7.38003 0 6.95003 0.38 6.89003 0.88L6.60003 3.19C6.19003 3.38 5.80003 3.61 5.43003 3.87L3.28003 2.96C2.82003 2.76 2.28003 2.94 2.03003 3.38L0.160031 6.62C-0.0899687 7.06 0.0200313 7.61 0.420031 7.92L2.28003 9.33C2.26003 9.55 2.25003 9.77 2.25003 10C2.25003 10.23 2.26003 10.45 2.28003 10.68L0.420031 12.09C0.0200313 12.39 -0.0899687 12.95 0.160031 13.39L2.03003 16.62C2.28003 17.06 2.82003 17.24 3.28003 17.04L5.43003 16.13C5.80003 16.39 6.19003 16.62 6.60003 16.81L6.89003 19.12C6.95003 19.62 7.38003 20 7.88003 20H11.61C12.11 20 12.54 19.62 12.6 19.12L12.89 16.81C13.3 16.62 13.69 16.39 14.06 16.13L16.21 17.04C16.67 17.24 17.21 17.06 17.46 16.62L19.33 13.39C19.58 12.95 19.47 12.4 19.07 12.09L17.21 10.68C17.24 10.45 17.25 10.23 17.25 10ZM9.79003 13.5C7.86003 13.5 6.29003 11.93 6.29003 10C6.29003 8.07 7.86003 6.5 9.79003 6.5C11.72 6.5 13.29 8.07 13.29 10C13.29 11.93 11.72 13.5 9.79003 13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.8ea0e7f85a0f507846ab5fe48741e1e2.svg";
export { ForwardRef as ReactComponent };